/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import DeliveryDetailModel from 'cio/models/delivery-detail';
import EnvironmentService from 'cio/services/environment';
import DS from 'ember-data';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

interface DraftEditorArgs {
  draft: DeliveryDetailModel;
  disabled: boolean;
}

export default class DraftEditor extends Component<DraftEditorArgs> {
  @service environment!: EnvironmentService;
  @service store!: DS.Store;

  @tracked wysiwyg = true;
  @tracked identityNames: string[] = [];

  constructor(owner: unknown, args: DraftEditorArgs) {
    super(owner, args);

    let { identities } = this.environment.current;
    this.identityNames = identities.map((identity) => identity.address);
  }

  @action
  toggleEditor() {
    this.wysiwyg = !this.wysiwyg;
  }
}
